export default __webpack_public_path__ + "static/media/footwear.e4b24bfd.jpg";